module.exports = "<div class=\"text-center\">\n\t<div class=\"preloader-wrapper big active\">\n\t\t<div class=\"spinner-layer spinner-blue-only\">\n\t\t\t<div class=\"circle-clipper left\">\n\t\t\t\t<div class=\"circle\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"gap-patch\">\n\t\t\t\t<div class=\"circle\"></div>\n\t\t\t</div>\n\t\t\t<div class=\"circle-clipper right\">\n\t\t\t\t<div class=\"circle\"></div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/Projects/anoki/src/app/layout/loader/loader.component.html
// module id = ../../../../../src/app/layout/loader/loader.component.html
// module chunks = main